
<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <v-layout column align-center>
          <h2 class="mb-0">Configured Markets</h2>
        </v-layout>
      </v-card-title>

      <v-card-media>
        <v-layout column align-center>
          <p class="error" v-if="errorMessage">An error was encountered: '{{ errorMessage }}'</p>
          <ul>
            <li v-for="m in markets" :key="m.id">{{ m.name }}</li>
          </ul>
        </v-layout>
      </v-card-media>

      <v-card-actions>
        <v-layout column align-end>
          <v-btn flat color="blue" @click='refreshMarkets()'>Refresh</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'configured-markets',
  data () {
    return {
      errorMessage: null,
    }
  },

  methods: {
    refreshMarkets: function() {
      this.$store.dispatch('getMarkets')
    }
  },

  computed: {
    markets() {
      return this.$store.getters.markets
    }
  }
}

</script>


<style scoped>
.error {
  color: red;
}

</style>